import * as React from 'react';
import clsx from 'clsx';
import { toCamelOrPascalCase as toPascalCase } from '@ovpn-ui/utils';
import TablerIcon from './TablerIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const isProd = process.env.NODE_ENV === 'production';
export default function createTablerIcon({
  Content,
  name,
  predefinedProps
}) {
  const Icon = /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/_jsx(TablerIcon, {
    ...predefinedProps,
    ...props,
    ...((predefinedProps == null ? void 0 : predefinedProps.className) && {
      className: clsx(predefinedProps.className, props.className)
    }),
    name: name,
    forwardedRef: ref,
    children: Content()
  })));
  return isProd ? Icon : Object.assign(Icon, {
    displayName: `${toPascalCase(name, true)}Icon`
  });
}